import React from "react";
import { useState } from "react";
import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function LikeButton({ product, size = "sm", onChange, className = "" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [liked, setLiked] = useState(!!product.liked);
  const [count, setCount] = useState(product.likes_count || 0);
  const [busy, setBusy] = useState(false);

  const toggle = async (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (!user) {
      toast.info("Masuk dulu untuk like produk");
      nav("/login");
      return;
    }
    if (busy) return;
    setBusy(true);
    // optimistic
    const prevLiked = liked, prevCount = count;
    setLiked(!liked);
    setCount(liked ? Math.max(0, count - 1) : count + 1);
    try {
      const { data } = await api.post(`/products/${product.id}/like`);
      setLiked(data.liked);
      setCount(data.likes_count);
      onChange?.(data);
    } catch (err) {
      setLiked(prevLiked);
      setCount(prevCount);
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  const isLg = size === "lg";
  return (
    <button
      onClick={toggle}
      data-testid={`like-btn-${product.id}`}
      aria-label={liked ? "Unlike" : "Like"}
      className={`inline-flex items-center gap-1 border border-black ${isLg ? "px-3 py-2" : "px-2 py-1"} font-mono ${isLg ? "text-xs" : "text-[10px]"} font-bold uppercase tracking-widest transition-colors ${
        liked ? "bg-[#FF3333] text-white" : "bg-white text-black hover:bg-[#FF3333] hover:text-white"
      } ${className}`}
    >
      <Heart className={`${isLg ? "w-4 h-4" : "w-3 h-3"} ${liked ? "fill-current" : ""}`} />
      <span data-testid={`like-count-${product.id}`}>{count}</span>
    </button>
  );
}

